export default __webpack_public_path__ + "static/media/info-icon2.1187779a.svg";